import environment from '../environment.json';

export class ErrorLog {
    static async log(message?: any, ...params: any[]) {
        if (environment.logErrors) {
            console.log(message, ...params)
        }
    }
}
